import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";

export interface WebhookTestButtonProps {
  handleTestWebhook: () => void;
  isDisabled: boolean;
  isTestingWebhook: boolean;
  isWebhookTested: boolean;
  isWebhookTestSuccessful: boolean;
  isWebhookUrlChanged: boolean;
  triggerType: string;
}

export const WebhookTestButton = ({
  handleTestWebhook,
  isDisabled,
  isTestingWebhook,
  isWebhookTestSuccessful,
  isWebhookUrlChanged,
  isWebhookTested,
  triggerType,
}: WebhookTestButtonProps) => {
  const getTestButtonMessage = () => {
    const isTriggerTypeEmpty = !triggerType || triggerType === "";
    const shouldTestAgain =
      (!isWebhookTestSuccessful || isWebhookUrlChanged) && isWebhookTested;

    if (isTestingWebhook) {
      return t("settings.workflows.form.testing_webhook");
    }
    if (shouldTestAgain) {
      return t("settings.workflows.form.test_again");
    }
    if (isTriggerTypeEmpty) {
      return t("settings.workflows.form.select_entry_rule");
    }
    return t("settings.workflows.form.test_webhook");
  };

  return (
    <Button
      disabled={isDisabled}
      onClick={handleTestWebhook}
      large={false}
      variant="circle"
      type="button"
    >
      {getTestButtonMessage()}
    </Button>
  );
};
